import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
	{
		path: '',
		redirectTo: 'dashboard',
		pathMatch: 'full'
	},
	{
		path: 'dashboard',
		loadChildren: () => import('./views/dashboard/dashboard.routing').then(m => m.DashboardRoutes),
		data: { title: 'Inicio', breadcrumb: 'INICIO' }
	},
	{
		path: 'parameter',
		loadChildren: () => import('./views/parameter/parameter.routing').then(m => m.ParameterRoutes),
		data: { title: 'Parametro', breadcrumb: 'PARAMETRO' }
	},
	{
		path: 'fee',
		loadChildren: () => import('./views/fee/fee.routing').then(m => m.FeeRoutes),
		data: { title: 'Tarifario', breadcrumb: 'TARIFARIO' }
	},
	{
		path: '**',
		redirectTo: 'dashboard'
	}
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
